import typesOfReadings from '../../../../public/json/types-of-readings.json';

import { usePacketInput } from '../Contexts/PacketInputContext';
import { usePacketBase } from '../Contexts/PacketBaseContext';
import { useGenerateResources } from '../Hooks/useGenerateResource';

export const LiterallyAnythingInput = () => {
  const { inputType, setTopic, topic, genre } = usePacketInput();
  const { handleGenerateResources } = useGenerateResources();
  const { languageStandards = [], contentStandard = null } = usePacketBase();
  if (inputType.id !== 'topic') return null;

  const anyStandardsSelected = (languageStandards || []).length > 0 || !!contentStandard;
  const placeholder = anyStandardsSelected
    ? 'What would you like to focus on specifically?'
    : genre === typesOfReadings[0]
      ? 'What are you teaching? (Gravity, Main Idea...)'
      : 'Enter a topic and genre (Story about a time-traveling detective, Poem about oranges...)';

  return (
    <input
      autoFocus
      type='text'
      placeholder={placeholder}
      className='w-full px-2 pt-6 pb-8 border-none focus:ring-0 placeholder:text-gray-400 placeholder:font-light caret-emerald-600'
      onChange={(e) => {
        setTopic(e.target.value);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleGenerateResources();
        }
      }}
      value={topic}
    />
  );
};
